import React, { Component } from 'react'
import styled from 'styled-components'
import * as variables from '../../styles/variables'
import Button from './Button'
import classNames from 'classnames'
import Cookie from 'js-cookie'
import iconInfo from '../../images/icon-info.svg'

const InfoContainer = styled.div`
  font-size: 20px;
  // background: ${variables.colours.lightBlue};
  background: rgba(161, 220, 237, 0.16);
  border: 3px solid ${variables.colours.lightBlue};
  margin: 0px 0px 20px;
  padding: 10px 15px 13px;
  border-radius: 5px;
  color: #222;
  p {
    // line-height: 1.3;
  }

  ${props => props.small ? "font-size: 16px; line-height: 1.4;" : ''};

  // display: flex;
  // justify-content: flex-start;
  // align-items: flex-start;
  .content-container {
    display: flex;
    // justify-content: center;
    align-items: flex-start;
  }
  img {
    margin-right: 15px;
    margin-top: 5px;
  }
  .content {
    // flex: 1;
    p:last-of-type {
      margin-bottom: 0;
    }
  }
  .close-container {
    margin-top: 10px;
    padding-left: 60px;
    @media screen and (min-width: 500px) {
      padding-left: 0px;
      text-align: right;
    }
  }
  .close {
    padding: 3px 15px;
    // margin-left: 20px;
    border-color: white;

    color: black;
    // text-decoration: underline;
    cursor: pointer;
  }
`

class Tip extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: !Cookie.get(`tip-${this.props.id}`),
    }
    this.close = this.close.bind(this)
  }

  close() {
    Cookie.set(`tip-${this.props.id}`, (new Date()).getTime(), { expires: 365 })
    this.setState({
      isOpen: false
    })
  }

  render() {
    if (!this.state.isOpen) {
      return null
    }
    else {
      return (
        <InfoContainer small={this.props.small}>
          <div className="content-container">
            <img src={iconInfo}/>
            <div className="content">{this.props.children}</div>
          </div>
          {!this.props.nodismiss && (
            <div className="close-container">
              <Button cancel="true" small="true" className="close" onClick={this.close}>Close this Tip</Button>
            </div>
          )}
        </InfoContainer>
      )
    }
  }
}

export default Tip